<!-- 签核记录 -->
<div class="main">
  <h4 [ngStyle]="{ 'margin-bottom.px': 16,'margin-top.px': 16 }">
    {{ 'ApprovalHistoryInfo.ApprovalHistory' | translate }}
    <em nz-icon [nzType]="'zoom-in'" (click)="activeTable = !activeTable"></em>
  </h4>
  <div class="main-body" *ngIf="activeTable && signData">
    <!-- xx工程-签核流程 -->
    <div *ngFor="let item of projectTypeInfo" class="main-right">
      <h4 class="table-title">{{ item.text | translate }}</h4>
      <nz-table *ngIf="signData[item.value]" #middleTable nzSize="small" [nzShowPagination]="false"
        [nzPageSize]="signData[item.value].length"
        [nzData]="signData[item.value]">
        <thead>
          <tr>
            <th nzWidth="8%" scope="col">{{ 'ApprovalHistoryInfo.SerialNumber' | translate }}</th>
            <th nzWidth="25%" scope="col">{{ 'ApprovalHistoryInfo.ApprovalSteps' | translate }}</th>
            <th nzWidth="20%" scope="col">{{ 'ApprovalHistoryInfo.Approver' | translate }}</th>
            <th nzWidth="20%" scope="col">{{ 'ApprovalHistoryInfo.ApprovalDate' | translate }}</th>
            <th nzWidth="12%" scope="col">{{ 'ApprovalHistoryInfo.ApprovalResults' | translate }}</th>
            <th nzWidth="15%" scope="col">{{ 'ApprovalHistoryInfo.Comments' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of middleTable.data">
            <td>{{ signData[item.value].indexOf(data)+1 }}</td>
            <td>{{ data.signStepValue }}</td>
            <td>{{ data.name }}</td>
            <td>{{ data.datetime }}</td>
            <td>{{ data.statusValue}}</td>
            <td>{{ data.remark }}</td>
          </tr>
        </tbody>
      </nz-table>
    </div>
    <div style="clear:both;"></div>
  </div>
</div>
